import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import BookingApi from "../../API/Apis/BookingApi";
import { t } from "i18next";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { AppStandardButton } from "../../components/UI/AppButtons";
import createTheme from "@mui/material/styles/createTheme";
import type { Theme } from "@mui/material/styles";
import { formatThemeForReservedArea } from "../../config/MuiColorThemes";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import {
  requestParentResize,
  getParentOrigin,
  allowedOrigins,
} from "../../helpers/iframeSource";

export function Profile() {
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  const isDesktopScreen = window.innerWidth >= 1310;
  const isSmallScreen = window.innerWidth <= 768;
  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const [userId] = useState(localStorage.getItem("userID"));
  const [, setReservedArea] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };
  const [profileDetails, setProfileDetails] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    userImage: "",
    dateOfBirth: "",
  });

  const handlePhoneNo = (event) => {
    let value = event.target.value;
    if (value.startsWith("+")) {
      value = "+" + value.slice(1).replace(/\D/g, "");
      if (value.length > 13) {
        value = value.slice(0, 13);
      }
    } else {
      value = value.replace(/\D/g, "");
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
    }

    setProfileDetails({ ...profileDetails, phoneNumber: value });
  };

  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };

  useEffect(() => {
    const id: any = localStorage.getItem("userID");
    if (userId != null && userId != "null" && userId != "") {
      BookingApi.getUserProfileByUserId(id).then((e) => {
        if (e === "Unauthorized access") {
          showNewIFrame("showSignInPage");
        } else {
          setProfileDetails(e.data.onlineUser[0]);
        }
      });
    }
  }, []);
  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const theme = createTheme(dynamicPalette);
      setDynamicTheme(theme);
    }
    fetchTheme();
  }, []);
  function handleSubmit(event) {
    const id: any = localStorage.getItem("userID");
    event.preventDefault();
    BookingApi.UpdateUserProfileById(id, profileDetails).then((e) => {
      if (e.data.status) {
        setModalMessage(t("User Updated Successfully."));
        setOpenModal(true);
      } else {
        setModalMessage("Unable to Update");
        setOpenModal(true);
        window.location.reload();
      }
      return e.data;
    });
  }
  const handleNameChange = (e) => {
    const nameParts = e.target.value.trim().split(/\s+/);
    const newFirstName = nameParts[0] || "";
    const newLastName = nameParts.slice(1).join(" ");
    setProfileDetails((prevDetails) => ({
      ...prevDetails,
      firstName: newFirstName,
      lastName: newLastName,
    }));
  };

  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      setReservedArea(true);
    } else {
      setReservedArea(false);
    }
  }, [userId]);

  useEffect(() => {
    requestParentResize(isDesktopScreen, 770, 630);
  }, []);
  return (
    <div>
      <>
        <div
          style={{
            color: "white",
            display: "none",
          }}
        >
          <CollapsibleNavbar
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
      </>
      <div className="flex">
        {!isSmallScreen && (
          <div className="!w-780" style={{ width: "300px" }}>
            <BookingDetalisListSideNavigation />
          </div>
        )}
        <div className="flex flex-col pt-12">
          <div
            className="text-[#333] mb-4"
            style={{
              width: !isSmallScreen ? "100%" : "90%",
              marginLeft: !isSmallScreen ? "13%" : "1rem",
              paddingTop: "16px",
            }}
          >
            <h1
              className="text-[28px] font-normal"
              style={{
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: isSmallScreen ? "24px" : "36px",
              }}
            >
              {t("Account information")}
            </h1>
            <h3
              className="text-[18px] text-[#838181]"
              style={{
                fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                fontSize: isSmallScreen ? "14px" : "16px",
              }}
            >
              {t(
                "Your account information is here you can edit your details from here"
              )}
            </h3>
          </div>
          <form className=" flex-col" onSubmit={handleSubmit}>
            <Container component="main">
              <Card sx={{ minWidth: isSmallScreen ? 260 : 600 }}>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={3}>
                    <Grid container alignItems="center">
                      <Card sx={{ minWidth: isSmallScreen ? 200 : 600 }}>
                        <Box
                          sx={{
                            marginBottom: 5,
                            padding: "5px",
                            display: "flex",
                          }}
                        >
                          {!isSmallScreen && (
                            <div
                              className="flex"
                              style={{ marginLeft: "20px" }}
                            >
                              <Avatar
                                src="/assets/images/AvtarProfilePage.png"
                                sx={{
                                  margin: 2,
                                  width: 70,
                                  height: 70,
                                }}
                              />
                            </div>
                          )}
                          <div className="p-4">
                            {isSmallScreen && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  src="/assets/images/AvtarProfilePage.png"
                                  sx={{
                                    margin: 2,
                                    width: 70,
                                    height: 70,
                                  }}
                                />
                              </div>
                            )}
                            <div style={{ marginBottom: "-13px" }}>
                              <label
                                style={{
                                  color: "#000000",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "18px",
                                }}
                              >
                                {t("Full name")}
                              </label>
                            </div>
                            <TextField
                              margin="normal"
                              required
                              style={{
                                width: isSmallScreen ? "315px" : "418px",
                                height: "38px",
                                color: "black",
                              }}
                              InputProps={{
                                className: "MBCorpoSTitle-CondRegular-Web-new",
                                sx: {
                                  height: "38px",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "12px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  "&.MuiInputLabel-root": {
                                    fontFamily:
                                      "MBCorpoSTitle-CondRegular-Web-new",
                                  },
                                },
                              }}
                              value={[
                                profileDetails?.firstName,
                                profileDetails?.lastName,
                              ]
                                .filter(Boolean)
                                .join(" ")}
                              name="fullName"
                              onChange={handleNameChange}
                            />
                            <div style={{ marginBottom: "-13px" }}>
                              <label
                                style={{
                                  color: "#000000",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "18px",
                                }}
                              >
                                {t("Email")}
                              </label>
                            </div>
                            <TextField
                              margin="normal"
                              required
                              style={{
                                width: isSmallScreen ? "315px" : "418px",
                                height: "38px",
                                color: "black",
                              }}
                              InputProps={{
                                className: "MBCorpoSTitle-CondRegular-Web-new",
                                sx: {
                                  height: "38px",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "12px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  "&.MuiInputLabel-root": {
                                    fontFamily:
                                      "MBCorpoSTitle-CondRegular-Web-new",
                                  },
                                },
                              }}
                              disabled={true}
                              name="email"
                              value={profileDetails?.email}
                              id="email"
                            />
                            <div style={{ marginBottom: "-13px" }}>
                              <label
                                style={{
                                  color: "#000000",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "18px",
                                }}
                              >
                                {t("Enter Phone Number")}
                              </label>
                            </div>
                            <TextField
                              name="phoneNumber"
                              id="phoneNumber"
                              value={profileDetails?.phoneNumber}
                              margin="normal"
                              required
                              style={{
                                width: isSmallScreen ? "315px" : "418px",
                                height: "38px",
                                color: "black",
                              }}
                              InputProps={{
                                className: "MBCorpoSTitle-CondRegular-Web-new",
                                sx: {
                                  height: "38px",
                                  fontFamily:
                                    "MBCorpoSTitle-CondRegular-Web-new",
                                  fontSize: "12px",
                                },
                              }}
                              inputProps={{
                                maxLength: 15,
                                inputMode: "tel",
                                pattern: "[0-9+]*",
                              }}
                              InputLabelProps={{
                                sx: {
                                  "&.MuiInputLabel-root": {
                                    fontFamily:
                                      "MBCorpoSTitle-CondRegular-Web-new",
                                  },
                                },
                              }}
                              onChange={handlePhoneNo}
                            />
                            <div
                              className={`flex gap-4 flex-col  mt-1 ${
                                !isSmallScreen ? "mr-[65%] mt-[20px]" : ""
                              }`}
                            >
                              <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                  gap: 3,
                                  fontWeight: "bold",
                                  bgcolor:
                                    dynamicTheme?.palette?.["primary"]?.main,
                                  textTransform: "capitalize",
                                }}
                                style={{
                                  backgroundColor:
                                    dynamicTheme?.palette?.["primary"]?.main,
                                  width: !isSmallScreen ? "10%" : "315px",
                                  fontFamily: "MBCorpoSText-Bold-Web-new",
                                }}
                              >
                                {t("Save")}
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Container>
          </form>
        </div>
        <Dialog
          open={openModal}
          onClose={requestOnClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{ style: { borderRadius: "20px" } }}
        >
          <DialogTitle style={{ padding: "3rem" }}>{modalMessage}</DialogTitle>

          <DialogActions style={{ justifyContent: "center" }}>
            <AppStandardButton variant="outlined" onClick={requestOnClose}>
              <p className="text-black normal-case">{t("Close")}</p>
            </AppStandardButton>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}
